import classNames from 'classnames';

import styles from './mochi-card.module.sass';

export const MochiCard = ({ children, className }) => {
  return (
    <div className={classNames(styles['card'], className)}>{children}</div>
  );
};
